import { _decorator, Node } from 'cc';
import MultiThemeComponent from './MultiThemeComponent';

const { ccclass, menu } = _decorator;

/**
 * this component should be using as a bind target of other MultiThemeComponent
 */
@ccclass('MultiThemeSource')
@menu('MultiTheme/MultiThemeSource')
export default class MultiThemeSource extends MultiThemeComponent<Node> {
    public getMaxTheme(): number {
        // This component does not have a theme count, it serves as a source for other components.
        return Number.MAX_SAFE_INTEGER;
    }

    protected getTarget() {
        return this.node;
    }

    protected onThemeChanged() {}
}
